import useGetUserSettingsQuery from '../../../hooks/domain/user/queries/useGetUserSettingsQuery';

export const useIsInitialized = () => {
  const { data: userSettings } = useGetUserSettingsQuery();
  return userSettings?.isInitialized;
};
